import React from 'react';
import Text from './text';

const Heading = props => <Text fontSize={3} fontWeight="medium" {...props} />;

export default Heading;
